/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkStatus } from '../models/work-status';

@Injectable({ providedIn: 'root' })
export class WorkStatusesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `statusV1ControllerFindAll()` */
  static readonly StatusV1ControllerFindAllPath = '/v1/statuses';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statusV1ControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  statusV1ControllerFindAll$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkStatus>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkStatusesService.StatusV1ControllerFindAllPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkStatus>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statusV1ControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  statusV1ControllerFindAll(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkStatus>> {
    return this.statusV1ControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkStatus>>): Array<WorkStatus> => r.body)
    );
  }

}
